// utils/security/PrivateRoute.js

import React, { useEffect, useState } from "react";

import { Container } from "react-bootstrap";
import { Navigate } from "react-router-dom";
import Spinner from "../../components/Reusable/Spinner";
import ThemeWrapper from "../../components/ThemeWrapper";
import { useSelector } from "react-redux";

const PrivateRoute = ({
  redirectPath = "/?login=true",
  component: Component,
  ...otherProps
}) => {
  const { userData, hasChecked } = useSelector((state) => state.userReducer);
  const [showLoader, setShowLoader] = useState(true);

  // ⏱ mali debounce da spreči "treptanje"
  useEffect(() => {
    if (hasChecked) {
      const timer = setTimeout(() => setShowLoader(false), 300);
      return () => clearTimeout(timer);
    }
  }, [hasChecked]);

  // ⛔ dok proveravaš auth — ništa ne renderuj (sprečava flicker)
  if (!hasChecked || showLoader) {
    return (
      <div className="loader-overlay">
        <Spinner />
      </div>
    );
  }

  // ❌ nije ulogovan
  if (!userData || !userData.firstName) {
    return <Navigate to={redirectPath} replace />;
  }

  // ✅ ulogovan
  return (
    <Container fluid>
      <ThemeWrapper>
        <Component {...otherProps} />
      </ThemeWrapper>
    </Container>
  );
};

export default PrivateRoute;
